import React from "react"
import { SupportedLocale } from "components/views/app/IntlMessages"
import { isOneTrustCookieCategoryAccepted, OneTrustCookieCategory } from "utils/oneTrustCookieConsent"
import { useIntl } from "react-intl"

const VimeoDoNotTrackQueryParameterName = "dnt"
const enum VimeoDoNotTrack {
  TrackingBlocked = "1",
  TrackingAllowed = "0"
}

type VimeoVideoProps = {
  videoUrl: string
  title: string
}

const VimeoTextTrackParameterName = "textTrack"

const withQueryParameters = (videoUrl: string, preferredLocale: SupportedLocale): string => {
  const videoUrlObject = new URL(videoUrl)

  videoUrlObject.searchParams.append(
    VimeoDoNotTrackQueryParameterName,
    isOneTrustCookieCategoryAccepted(OneTrustCookieCategory.Targeting)
      ? VimeoDoNotTrack.TrackingAllowed
      : VimeoDoNotTrack.TrackingBlocked
  )

  if (preferredLocale === SupportedLocale.Spanish_UnitedStates) {
    videoUrlObject.searchParams.append(VimeoTextTrackParameterName, "es-419")
  } else videoUrlObject.searchParams.append(VimeoTextTrackParameterName, preferredLocale)

  return videoUrlObject.href
}

export function VimeoVideo({ videoUrl, title }: VimeoVideoProps): JSX.Element {
  const intl = useIntl()
  const locale: SupportedLocale = intl.locale as SupportedLocale

  return (
    <div className="embed-container">
      <iframe
        data-ot-ignore /* must be first! 😲 */
        className="bn"
        title={title}
        src={withQueryParameters(videoUrl, locale)}
        allowFullScreen
      />
    </div>
  )
}
